import client from '../client';
import {
  BASE_ENDPOINTS,
  RESOURCES,
  SERVICES,
  VERSIONS
} from '../common/constants';

const HYDROLOGY_MONITOR_BASE_V2 = BASE_ENDPOINTS.createEndpoint(
  SERVICES.HYDROLOGY,
  VERSIONS.V2,
  'monitor', // Resource name for terrestrial evaluation
  false // No tenant ID in the base URL
);

const HYDROLOGY_EVALUATE_BASE_V1 = BASE_ENDPOINTS.createEndpoint(
  SERVICES.HYDROLOGY,
  VERSIONS.V1,
  'evaluate', // Resource name for terrestrial evaluation
  false // No tenant ID in the base URL
);

const HYDROLOGY_FARMLAND_BASE_V2 = BASE_ENDPOINTS.createEndpoint(
  SERVICES.HYDROLOGY,
  VERSIONS.V2,
  'farmland', // Resource name for terrestrial evaluation
  false // No tenant ID in the base URL
);

const HYDROLOGY_COMPARE_BASE_V1 = BASE_ENDPOINTS.createEndpoint(
  SERVICES.HYDROLOGY,
  VERSIONS.V1,
  'compare', // Resource name for terrestrial evaluation
  false // No tenant ID in the base URL
);

export const getHydrologicalMonitoring = cluster =>
  client.get(`${HYDROLOGY_MONITOR_BASE_V2}/${cluster}/`);

export const getHydrologicalEvaluation = cluster =>
  client.get(`${HYDROLOGY_EVALUATE_BASE_V1}/${cluster}/`);

export const getHydrologyData = ({ tenant_id, parent_id, project_ids }) =>
  client.post(`${HYDROLOGY_FARMLAND_BASE_V2}/`, {
    tenant_id: tenant_id,
    parent_id: parent_id,
    project_ids: project_ids
  });

export const getHydrologicalComparison = data =>
  client.post(`${HYDROLOGY_COMPARE_BASE_V1}/`, data);
